// The Recovery Shift — theme behavior

document.addEventListener('DOMContentLoaded', function () {
  initMobileNav();
  initGalleries();
  initVariantPickers();
  initQuantityInputs();
});

function initMobileNav() {
  document.querySelectorAll('[data-nav-toggle]').forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var nav = document.querySelector(toggle.getAttribute('data-nav-toggle'));
      if (nav) nav.classList.toggle('open');
    });
  });
}

function initGalleries() {
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!main) return;
        main.src = thumb.getAttribute('data-full') || thumb.querySelector('img').src;
        main.alt = thumb.getAttribute('data-alt') || main.alt;
        thumbs.forEach(function (t) { t.querySelector('img').classList.remove('active'); });
        thumb.querySelector('img').classList.add('active');
      });
    });
  });
}

function initQuantityInputs() {
  document.querySelectorAll('[data-quantity]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.getAttribute('data-step'), 10);
        var value = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.value = value;
        input.dispatchEvent(new Event('change'));
      });
    });
  });
}

function initVariantPickers() {
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var dataEl = form.querySelector('[data-variants-json]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = form.querySelector('[data-price]');
    var compareEl = form.querySelector('[data-compare-price]');
    var saveEl = form.querySelector('[data-save-badge]');
    var addBtn = form.querySelector('[data-add-to-cart]');
    var soldOutText = form.getAttribute('data-sold-out-text') || 'Sold out';
    var unavailableText = form.getAttribute('data-unavailable-text') || 'Unavailable';
    var addText = form.getAttribute('data-add-text') || 'Add to cart';

    var selected = {};
    form.querySelectorAll('[data-option-index]').forEach(function (group) {
      var active = group.querySelector('.chip.active');
      selected[group.getAttribute('data-option-index')] = active ? active.getAttribute('data-value') : null;
    });

    function findVariant() {
      return variants.find(function (v) {
        return Object.keys(selected).every(function (idx) {
          return v.options[parseInt(idx, 10)] === selected[idx];
        });
      });
    }

    function money(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function render() {
      var variant = findVariant();
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = unavailableText; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = money(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (saveEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          saveEl.textContent = 'Save ' + money(variant.compare_at_price - variant.price);
          saveEl.style.display = '';
        } else {
          saveEl.style.display = 'none';
        }
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? (addText + ' — ' + money(variant.price)) : soldOutText;
      }
    }

    form.querySelectorAll('[data-option-index] .chip').forEach(function (chip) {
      chip.addEventListener('click', function () {
        var group = chip.closest('[data-option-index]');
        group.querySelectorAll('.chip').forEach(function (c) { c.classList.remove('active'); });
        chip.classList.add('active');
        selected[group.getAttribute('data-option-index')] = chip.getAttribute('data-value');
        render();
      });
    });

    render();
  });
}
